export const isDevBuild = (): boolean => process.env.NODE_ENV !== 'production';

const rawApiOrigin = process.env.REACT_APP_API_URL ?? '';
export const apiOrigin = rawApiOrigin.trim().replace(/\/+$/, '');
